export const PlanProfiles = Object.freeze({
  uk_billing_shipments: {
    id: 10,
    name: 'UK Billing Variant 1 (Shipments)',
    planProfileCode: 'uk_billing_shipments',
  },
  uk_billing_orders: {
    id: 11,
    name: 'UK Billing Variant 2 (Orders)',
    planProfileCode: 'uk_billing_orders',
  },
  eu_billing: {
    id: 112,
    name: 'EU Billing',
    planProfileCode: 'eu_billing',
  },
  '2022_q3': {
    id: 115,
    name: '2022 Q3',
    planProfileCode: '2022_q3',
  },
  ss_anz_q12023: {
    id: 117,
    name: 'ANZ PLF Q12023',
    planProfileCode: 'ss_anz_q12023',
  },
  byoa_billing_2023_q2: {
    id: 118,
    name: 'Plans Subject to Non-Wallet Surcharge',
    planProfileCode: 'byoa_billing_2023_q2',
  },
  ss_eu_2023_q2: {
    id: 119,
    name: 'EU Billing 2023 Q2',
    planProfileCode: 'ss_eu_2023_q2',
  },
  ss_uk_2023_q2: {
    id: 120,
    name: 'UK Billing 2023 Q2',
    planProfileCode: 'ss_uk_2023_q2',
  },
  ss_eu_byoa_2023_q2: {
    id: 121,
    name: 'EU Billing BYOA 2023 Q2',
    planProfileCode: 'ss_eu_byoa_2023_q2',
  },
  ss_uk_byoa_2023_q2: {
    id: 122,
    name: 'UK Billing BYOA 2023 Q2',
    planProfileCode: 'ss_uk_byoa_2023_q2',
  },
  goodbetterbest_2025_q2: {
    id: 123,
    name: '2025 Q2',
    planProfileCode: 'goodbetterbest_2025_q2',
  },
  gbb_migration_2026q2: {
    id: 124,
    name: 'GoodBetterBest 2026 Q2 Migration',
    planProfileCode: 'gbb_migration_2026q2',
  },
});

/** @constant {118} */
export const NonWalletedPlanProfileId = PlanProfiles.byoa_billing_2023_q2.id;

export const EU_PLAN_PROFILE_CODES = [
  PlanProfiles.eu_billing.planProfileCode,
  PlanProfiles.ss_eu_2023_q2.planProfileCode,
  PlanProfiles.ss_eu_byoa_2023_q2.planProfileCode,
];

export const UK_PLAN_PROFILE_CODES = [
  PlanProfiles.uk_billing_shipments.planProfileCode,
  PlanProfiles.uk_billing_orders.planProfileCode,
  PlanProfiles.ss_uk_2023_q2.planProfileCode,
  PlanProfiles.ss_uk_byoa_2023_q2.planProfileCode,
];

export const PLAN_PROFILES_WITH_PER_LABEL_FEE = [
  PlanProfiles.ss_anz_q12023.planProfileCode,
  PlanProfiles.ss_eu_byoa_2023_q2.planProfileCode,
  PlanProfiles.ss_uk_byoa_2023_q2.planProfileCode,
];

export const EU_UK_PLAN_PROFILE_CODES = [...EU_PLAN_PROFILE_CODES, ...UK_PLAN_PROFILE_CODES];

export const isPlanCodeByoa = (planCode) => planCode?.toLowerCase().includes('byoa');
